// Loads all article JSON files from src/data/articles/ at build time via Vite glob.

export type ArticleFaq = { q: string; a: string };
export type ArticleSource = { label: string; url: string };

export type Article = {
  slug: string;
  title: string;
  category: "IA" | "Negocios" | "Economía" | "Tecnología" | "Marketing";
  source: string;
  sourceUrl: string;
  date: string;
  featured?: boolean;
  summary: string;
  impact: string;
  seoTitle?: string;
  seoDescription?: string;
  keywords?: string[];
  tldr?: string;
  readingTime?: number;
  body: string;
  faqs?: ArticleFaq[];
  sources?: ArticleSource[];
};

const modules = import.meta.glob<Article>("./articles/*.json", {
  eager: true,
  import: "default",
});

export const ARTICLES: Article[] = Object.values(modules).sort(
  (a, b) => +new Date(b.date) - +new Date(a.date),
);

export const ARTICLES_BY_SLUG: Record<string, Article> = ARTICLES.reduce(
  (acc, a) => {
    acc[a.slug] = a;
    return acc;
  },
  {} as Record<string, Article>,
);

export const getArticleBySlug = (slug?: string): Article | undefined =>
  slug ? ARTICLES_BY_SLUG[slug] : undefined;
